const postGroupsStr = {
  postGroups: 'Grupo agregado',
  postGroups1: ' fue agregado con éxito',
  toastrError: 'Nombre ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default postGroupsStr;
